import { makeAutoObservable, runInAction, toJS } from "mobx";
import { carbonInventoryService } from "../services";
import { showToast } from "@/lib/utils/toast";

class CarbonDashboardStore {
  selectedYear = 2026;
  carbonTargets = {};
  carbonSubmissionsData = [];
  carbonOverviewData = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: false });
  }

  loadCarbonBankSubmissions = async (year) => {
    try {
      const data = await carbonInventoryService.getCarbonBankSubmission(
        year,
        "approved",
      );
      runInAction(() => {
        this.carbonSubmissionsData = data?.submissions;
      });
    } catch (error) {
      showToast.error(error?.message || "Failed to load!");
    }
  };

  loadCarbonBankOverview = async (year) => {
    try {
      const data = await carbonInventoryService.getCarbonBankOverview(
        year,
        "approved",
      );
      runInAction(() => {
        this.carbonOverviewData = data;
      });
    } catch (error) {
      showToast.error(error?.message || "Failed to load!");
    }
  };

  loadCarbonTargets = async () => {
    try {
      const data = await carbonInventoryService.getCarbonTargets();
      if (!data) {
        throw new Error("Failed to load carbon targets.");
      }
      this.carbonTargets = data;
    } catch (error) {
      showToast.error(error?.message || "Failed to load carbon targets.");
      return false;
    }
  };
}
export const carbonDashboardStore = new CarbonDashboardStore();
